import './sections/most-read/main.ts';
import './sections/menu/main.ts';
import './sections/sort-widget/main.ts';


function initMoreButton() {
  let button: HTMLElement | null;
  const container = document.querySelector('.news-overview-container');

  if (!container) return;

  async function addNews() {

    if (!button || !container) return;

    const url = button.dataset.href as string;
    const response = await fetch(url);
    const json = await response.json();

    button.outerHTML = '';
    container.insertAdjacentHTML('beforeend', json.data);
    attachHandlerToButton();
  }
  
  function attachHandlerToButton() {
    button = document.querySelector('.pager') as HTMLElement | null;
    if (button) {
      button.addEventListener('click', (event: MouseEvent) => {
        addNews();
        event.preventDefault();
      });
    }
  }
  attachHandlerToButton();

}

initMoreButton();

